import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { personaApiURL } from './apiRoutes';
import { PersonaSearch } from "../models/persona/personaSearch";


@Injectable({
    providedIn: 'root',
})
export class PersonaSearchService {
    constructor(public http: HttpClient) { }

    getPersonas(data: string): Promise<PersonaSearch> {
        return this.http.get<PersonaSearch>(personaApiURL + '/quick-search/' + data).toPromise();
    }

}
